import {RouteObject} from 'react-router';
import {ROUTES} from '../routes';
import {ProtectedRoute} from '../auth/require-authorization';
import {CosSelectionOptionListing} from './cos-selection-option-listing';
import {CosSelectionOptionCreate, CosSelectionOptionUpdate} from './cos-selection-option-create-update';

export const CosSelectionOptionRoutes: RouteObject = {
  path: ROUTES.ADMIN.COS_SELECTION_OPTIONS.path,
  element: <ProtectedRoute role={'Global Admin'} />,
  children: [
    {
      path: ROUTES.ADMIN.COS_SELECTION_OPTIONS.INDEX.path,
      element: <CosSelectionOptionListing />,
    },
    {
      path: ROUTES.ADMIN.COS_SELECTION_OPTIONS.CREATE.path,
      element: <CosSelectionOptionCreate />,
    },
    {
      path: ROUTES.ADMIN.COS_SELECTION_OPTIONS.DETAIL.path,
      element: <CosSelectionOptionUpdate />,
    },
  ],
};
